<template>
  <div>
    <h2 class="page-title text-center">{{ $route.params.id ? 'Detail' : 'Tambah' }} Penilaian Pelaksanaan UPT</h2>
    <Widget customHeader>
      <b-tabs v-model="activeTab">
        <b-tab>
          <template slot="title">
            Identitas <span :class="indicatorIdentitasClass(form.identitas)">*</span>
          </template>
          <form-identitas v-model="form.identitas" @kembali="kembaliKeDaftar" @selanjutnya="keTabBerikutnya" @simpan="simpanTab('identitas')" />
        </b-tab>
        <b-tab>
          <template slot="title">
            Kemajuan Perizinan <span :class="indicatorKemajuanPerizinanClass(form.kemajuanPerizinan)">*</span>
          </template>
          <form-kemajuan-perizinan
            v-model="form.kemajuanPerizinan"
            :is-active="activeTab === 1"
            @kembali="keTabSebelumnya"
            @selanjutnya="keTabBerikutnya"
            @simpan="simpanTab('kemajuanPerizinan')"
          />
        </b-tab>
        <b-tab>
          <template slot="title">
            Kewajiban <span :class="indicatorKewajibanClass(form.kewajiban)">*</span>
          </template>
          <form-kewajiban v-model="form.kewajiban" @kembali="keTabSebelumnya" @selanjutnya="keTabBerikutnya" @simpan="simpanTab('kewajiban')" />
        </b-tab>
        <b-tab>
          <template slot="title">
            Wawancara <span :class="indicatorWawancaraClass(form.wawancara)">*</span>
          </template>
          <form-wawancara v-model="form.wawancara" @kembali="keTabSebelumnya" @selanjutnya="keTabBerikutnya" @simpan="simpanTab('wawancara')" />
        </b-tab>
        <b-tab>
          <template slot="title">
            Berita Acara <span :class="indicatorBeritaAcaraClass(form.beritaAcara)">*</span>
          </template>
          <form-berita-acara v-model="form.beritaAcara" @kembali="keTabSebelumnya" @selanjutnya="keTabBerikutnya" @simpan="simpanTab('beritaAcara')" />
        </b-tab>
        <b-tab>
          <template slot="title">
            Finalisasi <span :class="indicatorFinalisasiClass(form.finalisasi)">*</span>
          </template>
          <form-finalisasi v-model="form.finalisasi" @kembali="keTabSebelumnya" @simpan="simpanTab('finalisasi')" @submit="submitForm" />
        </b-tab>
      </b-tabs>
    </Widget>
    <b-modal v-model="showIncompleteTabsModal" title="Form Belum Lengkap" ok-only ok-title="Tutup" ok-variant="secondary">
      <p>Lengkapi field wajib pada tab berikut sebelum Submit:</p>
      <ol class="mb-0">
        <li v-for="tabName in incompleteTabNames" :key="tabName">{{ tabName }}</li>
      </ol>
    </b-modal>
  </div>
</template>

<script>
import formIdentitas from './formIdentitas.vue'
import formKemajuanPerizinan from './formKemajuanPerizinan.vue'
import formKewajiban from './formKewajiban.vue'
import formWawancara from './formWawancara.vue'
import formBeritaAcara from './formBeritaAcara.vue'
import formFinalisasi from './formFinalisasi.vue'
import { createEmptyInterviewAnswers, wawancaraQuestionGroups } from './wawancaraQuestions'
import { createEmptyKewajiban, kewajibanItems } from './kewajibanItems'

export default {
  name: 'formPenilaianPelaksanaanUpt',
  components: {
    formIdentitas,
    formKemajuanPerizinan,
    formKewajiban,
    formWawancara,
    formBeritaAcara,
    formFinalisasi,
  },
  data() {
    return {
      activeTab: 0,
      showIncompleteTabsModal: false,
      incompleteTabNames: [],
      form: {
        identitas: {
          nomor_kkprl: '',
          npwp: '',
          subjek_hukum: '',
          nib: '',
          provinsi: '',
          tanggal_terbit: '',
          nama_kegiatan: '',
          nama_detail_kegiatan: '',
          luas: '',
          panjang: '',
          nama_perairan: '',
          nama_kawasan_rtr: '',
          dasar_hukum_rtr: '',
          realisasi_pemanfaatan_ruang_laut: '',
          keterangan_realisasi: '',
          bukti_dukung: null,
          titik_koordinat: [],
        },
        kemajuanPerizinan: {
          perizinan: [
            { id: 1, kategori: '', nama_izin: '', nomor_izin: '', tanggal_terbit: '', masa_berlaku: '' },
          ],
          jenis_area: '',
          koordinat_perizinan: [],
        },
        kewajiban: createEmptyKewajiban(),
        wawancara: {
          tanggal_wawancara: '',
          waktu_mulai: '',
          waktu_selesai: '',
          zona_waktu: 'WIB',
          lokasi: '',
          pewawancara: null,
          nama_narasumber: '',
          alamat_narasumber: '',
          no_surat_tugas_kuasa: '',
          jawaban_pertanyaan: createEmptyInterviewAnswers(),
          catatan: '',
        },
        beritaAcara: {
          tanggal_ba: '',
          nomor_ba: '',
          provinsi: '',
          kabupaten: '',
          kecamatan: '',
          kelurahan: '',
          isi_berita_acara: '',
          penandatangan: [{
            id: 1,
            kategori: '',
            nama: '',
            jabatan: '',
            instansi_unit_kerja: '',
          }],
          dokumentasi: [],
          lampiran_peta_penilaian: [],
        },
        finalisasi: {
          persentase_realisasi: '',
          kriteria: '',
          kategori: '',
          luas_area_infrastruktur: '',
          persentase_area_infrastruktur: '',
          luas_area_non_infrastruktur: '',
          persentase_area_non_infrastruktur: '',
          kriteria_subjek_hukum: '',
          kategori_subjek_hukum: '',
          kriteria_persetujuan: '',
          kategori_persetujuan: '',
          kriteria_kewajiban_kkprl: '',
          kategori_kewajiban_kkprl: '',
          hasil_penilaian: '',
          catatan: '',
          tim_penilai: [{ id: 1, nama: '', jabatan: '', instansi_unit_kerja: '' }],
        },
      },
    }
  },
  methods: {
    indicatorClass(form) {
      const isComplete = Object.values(form).every(value => String(value || '').trim() !== '')
      return isComplete ? 'text-success' : 'text-danger'
    },
    indicatorFinalisasiClass(form) {
      const requiredFields = [
        'persentase_realisasi', 'kriteria', 'kategori', 'luas_area_infrastruktur',
        'persentase_area_infrastruktur', 'luas_area_non_infrastruktur', 'persentase_area_non_infrastruktur',
        'kriteria_subjek_hukum', 'kategori_subjek_hukum', 'kriteria_persetujuan',
        'kategori_persetujuan', 'kriteria_kewajiban_kkprl', 'kategori_kewajiban_kkprl',
      ]
      const hasRequiredValues = requiredFields.every(field => (
        String(form[field] === undefined || form[field] === null ? '' : form[field]).trim() !== ''
      ))
      const numericFields = [
        ['persentase_realisasi', true], ['luas_area_infrastruktur', false],
        ['persentase_area_infrastruktur', true], ['luas_area_non_infrastruktur', false],
        ['persentase_area_non_infrastruktur', true],
      ]
      const numericValuesAreValid = numericFields.every(([field, isPercentage]) => {
        const value = String(form[field] === undefined || form[field] === null ? '' : form[field]).trim()
        return /^\d+(\.\d{1,2})?$/.test(value) && (!isPercentage || Number(value) <= 100)
      })
      const choiceValuesAreValid = [
        ['kriteria', ['Sesuai', 'Tidak Sesuai']],
        ['kategori', ['Taat', 'Tidak Taat']],
        ['kriteria_subjek_hukum', ['Sesuai', 'Tidak Sesuai']],
        ['kategori_subjek_hukum', ['Taat', 'Tidak Taat']],
        ['kriteria_persetujuan', ['Sesuai', 'Tidak Sesuai']],
        ['kategori_persetujuan', ['Taat', 'Tidak Taat']],
        ['kriteria_kewajiban_kkprl', ['Dilaksanakan', 'Tidak Dilaksanakan']],
        ['kategori_kewajiban_kkprl', ['Taat', 'Tidak Taat']],
      ].every(([field, options]) => options.includes(form[field]))
      const hasValidResult = ['Taat', 'Taat dengan Catatan', 'Tidak Taat'].includes(form.hasil_penilaian)
      const hasCatatan = this.hasRichTextContent(form.catatan)
      const timPenilaiIsComplete = Array.isArray(form.tim_penilai) && form.tim_penilai.length > 0 &&
        form.tim_penilai.every(timPenilai => (
          String(timPenilai.nama || '').trim() !== '' &&
          String(timPenilai.jabatan || '').trim() !== '' &&
          String(timPenilai.instansi_unit_kerja || '').trim() !== ''
        ))
      return hasRequiredValues && numericValuesAreValid && choiceValuesAreValid &&
        hasValidResult && hasCatatan && timPenilaiIsComplete ? 'text-success' : 'text-danger'
    },
    indicatorBeritaAcaraClass(form) {
      const textFields = ['tanggal_ba', 'nomor_ba', 'provinsi', 'kabupaten', 'kecamatan', 'kelurahan']
      const hasRequiredFields = textFields.every(field => String(form[field] || '').trim() !== '')
      const validCategories = ['Penilai', 'Penanggung Jawab Pemrakarsa']
      const signatoriesAreComplete = Array.isArray(form.penandatangan) && form.penandatangan.length > 0 &&
        form.penandatangan.every((signatory) => (
          validCategories.includes(signatory.kategori) &&
          String(signatory.nama || '').trim() !== '' &&
          String(signatory.jabatan || '').trim() !== '' &&
          String(signatory.instansi_unit_kerja || '').trim() !== ''
        ))
      return hasRequiredFields && this.hasRichTextContent(form.isi_berita_acara) && signatoriesAreComplete
        ? 'text-success'
        : 'text-danger'
    },
    indicatorKewajibanClass(form) {
      const items = Array.isArray(form.items) ? form.items : []
      const allAssessmentsAreComplete = kewajibanItems.every((kewajiban) => {
        const item = items.find((entry) => entry.id === kewajiban.id)
        return item && ['Sesuai', 'Tidak Sesuai'].includes(item.hasil_penilaian)
      })

      return allAssessmentsAreComplete ? 'text-success' : 'text-danger'
    },
    indicatorWawancaraClass(form) {
      const hasValidTimeRange = form.waktu_mulai && form.waktu_selesai && form.waktu_selesai > form.waktu_mulai
      const isComplete = Boolean(
        String(form.tanggal_wawancara || '').trim() &&
        hasValidTimeRange &&
        ['WIB', 'WITA', 'WIT'].includes(form.zona_waktu) &&
        String(form.lokasi || '').trim() &&
        form.pewawancara !== null && form.pewawancara !== undefined && form.pewawancara !== '' &&
        String(form.nama_narasumber || '').trim() &&
        String(form.alamat_narasumber || '').trim() &&
        this.hasRichTextContent(form.catatan),
      )
      const answersAreComplete = wawancaraQuestionGroups.every((group) => (
        group.questions.every((question) => {
          const entry = (form.jawaban_pertanyaan || {})[question.id]
          if (!entry || !String(entry.penjelasan || '').trim()) return false
          if (group.answerType === 'conformity') return ['Sesuai', 'Tidak Sesuai'].includes(entry.jawaban)
          if (group.answerType === 'completion') return ['Sudah', 'Belum Dilaksanakan'].includes(entry.jawaban)
          return String(entry.jawaban || '').trim() !== ''
        })
      ))
      return isComplete && answersAreComplete ? 'text-success' : 'text-danger'
    },
    hasRichTextContent(content) {
      const text = String(content || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;|&#160;|&#xA0;|&ensp;|&emsp;|&thinsp;/gi, ' ')
      return text.trim() !== ''
    },
    indicatorKemajuanPerizinanClass(form) {
      const perizinanIsComplete = Array.isArray(form.perizinan) &&
        form.perizinan.length > 0 &&
        form.perizinan.every((izin) => {
          const masaBerlaku = Number(izin.masa_berlaku)
          return (
            String(izin.kategori || '').trim() !== '' &&
            String(izin.nama_izin || '').trim() !== '' &&
            String(izin.nomor_izin || '').trim() !== '' &&
            String(izin.tanggal_terbit || '').trim() !== '' &&
            Number.isFinite(masaBerlaku) &&
            masaBerlaku > 0
          )
        })
      const hasValidJenisArea = ['Luas', 'Panjang'].includes(form.jenis_area)
      const areaIsValid = form.jenis_area === 'Luas'
        ? this.isValidCoordinatePolygon(form.koordinat_perizinan)
        : form.jenis_area === 'Panjang' && this.isValidCoordinatePolyline(form.koordinat_perizinan)
      return perizinanIsComplete && hasValidJenisArea && areaIsValid ? 'text-success' : 'text-danger'
    },
    isValidCoordinatePolygon(coordinates) {
      if (coordinates.length < 3 || !coordinates.every(point => (
        Number.isFinite(Number(point.bujur)) && Number(point.bujur) >= -180 && Number(point.bujur) <= 180 &&
        Number.isFinite(Number(point.lintang)) && Number(point.lintang) >= -90 && Number(point.lintang) <= 90
      ))) return false

      const points = coordinates.map(point => [Number(point.lintang), Number(point.bujur)])
      if (new Set(points.map(point => point.join(','))).size < 3) return false

      let areaSum = 0
      points.forEach((point, index) => {
        const next = points[(index + 1) % points.length]
        const latitude = point[0] * Math.PI / 180
        const nextLatitude = next[0] * Math.PI / 180
        let longitudeDifference = (next[1] - point[1]) * Math.PI / 180
        if (longitudeDifference > Math.PI) longitudeDifference -= 2 * Math.PI
        if (longitudeDifference < -Math.PI) longitudeDifference += 2 * Math.PI
        areaSum += longitudeDifference * (2 + Math.sin(latitude) + Math.sin(nextLatitude))
      })
      return Math.abs(areaSum) > 0
    },
    isValidCoordinatePolyline(coordinates) {
      if (coordinates.length < 2 || !coordinates.every(point => (
        Number.isFinite(Number(point.bujur)) && Number(point.bujur) >= -180 && Number(point.bujur) <= 180 &&
        Number.isFinite(Number(point.lintang)) && Number(point.lintang) >= -90 && Number(point.lintang) <= 90
      ))) return false

      let distance = 0
      coordinates.slice(1).forEach((point, index) => {
        const previous = coordinates[index]
        const toRadians = degree => degree * Math.PI / 180
        const latitudeDifference = toRadians(Number(point.lintang) - Number(previous.lintang))
        const longitudeDifference = toRadians(Number(point.bujur) - Number(previous.bujur))
        const latitude1 = toRadians(Number(previous.lintang))
        const latitude2 = toRadians(Number(point.lintang))
        const haversine = Math.sin(latitudeDifference / 2) ** 2 +
          Math.cos(latitude1) * Math.cos(latitude2) * Math.sin(longitudeDifference / 2) ** 2
        distance += 2 * 6371008.8 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine))
      })
      return distance > 0
    },
    indicatorIdentitasClass(form) {
      const textFields = [
        'nomor_kkprl',
        'npwp',
        'subjek_hukum',
        'nib',
        'nama_kegiatan',
        'nama_detail_kegiatan',
        'luas',
        'panjang',
        'nama_perairan',
        'nama_kawasan_rtr',
        'dasar_hukum_rtr',
        'realisasi_pemanfaatan_ruang_laut',
        'keterangan_realisasi',
      ]
      const hasRequiredText = textFields.every(field => String(form[field] || '').trim() !== '')
      const file = form.bukti_dukung
      const hasPdf = file && (
        file.type === 'application/pdf' ||
        String(file.name || '').toLowerCase().endsWith('.pdf')
      )
      const coordinatesComplete = form.titik_koordinat.length > 0 && form.titik_koordinat.every((point) => (
        String(point.bujur || '').trim() !== '' &&
        String(point.lintang || '').trim() !== '' &&
        ['Sesuai', 'Tidak Sesuai'].includes(point.observasi)
      ))
      const isComplete = hasRequiredText && Boolean(form.provinsi) && Boolean(form.tanggal_terbit) && hasPdf && coordinatesComplete
      return isComplete ? 'text-success' : 'text-danger'
    },
    kembaliKeDaftar() {
      this.$router.push('/app/penilaian-pelaksanaan/upt')
    },
    keTabSebelumnya() {
      this.activeTab = Math.max(0, this.activeTab - 1)
    },
    keTabBerikutnya() {
      this.activeTab = Math.min(5, this.activeTab + 1)
    },
    simpanTab(tabKey) {
      const tabNames = {
        identitas: 'Identitas',
        kemajuanPerizinan: 'Kemajuan Perizinan',
        kewajiban: 'Kewajiban',
        wawancara: 'Wawancara',
        beritaAcara: 'Berita Acara',
        finalisasi: 'Finalisasi',
      }
      console.log(`Simpan tab ${tabNames[tabKey]}:`, this.form[tabKey])
    },
    submitForm() {
      const tabChecks = [
        { name: 'Identitas', isComplete: this.indicatorIdentitasClass(this.form.identitas) === 'text-success' },
        { name: 'Kemajuan Perizinan', isComplete: this.indicatorKemajuanPerizinanClass(this.form.kemajuanPerizinan) === 'text-success' },
        { name: 'Kewajiban', isComplete: this.indicatorKewajibanClass(this.form.kewajiban) === 'text-success' },
        { name: 'Wawancara', isComplete: this.indicatorWawancaraClass(this.form.wawancara) === 'text-success' },
        { name: 'Berita Acara', isComplete: this.indicatorBeritaAcaraClass(this.form.beritaAcara) === 'text-success' },
        { name: 'Finalisasi', isComplete: this.indicatorFinalisasiClass(this.form.finalisasi) === 'text-success' },
      ]
      this.incompleteTabNames = tabChecks.filter(tab => !tab.isComplete).map(tab => tab.name)
      if (this.incompleteTabNames.length) {
        this.showIncompleteTabsModal = true
        return
      }
      console.log('Form Penilaian Pelaksanaan UPT:', this.form)
    },
  },
}
</script>
